import React, { useEffect, useRef } from "react";
import { Box, Typography, Grid } from "@mui/material";
import "odometer/themes/odometer-theme-default.css";
import Odometer from "odometer";
import PrimaryHeading from "../../Utilities/PrimaryHeading";

const statsData = [
  { label: "Total Non-Conformities Managed", value: 1960, plus: true },
  { label: "Total Users Onboarded", value: 20, plus: true },
  { label: "Countries Served", value: 2, plus: true },
  { label: "Customer Satisfaction Rate", value: 99.95, plus: true },
];

const NumberCounter = () => {
  const odometerRefs = useRef([]);

  useEffect(() => {
    statsData.forEach((stat, index) => {
      const el = odometerRefs.current[index];
      const odometer = new Odometer({
        el,
        value: 0,
        theme: "default",
        format: stat.label === "Customer Satisfaction Rate" ? "(,ddd).dd" : "(,ddd)",
      });

      let hasRun = false;

      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting && !hasRun) {
            odometer.update(stat.value);
            hasRun = true;
          }
        },
        { threshold: 0.8 }
      );

      observer.observe(el);
    });
  }, []);

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      minHeight: '340px',
      pt: 2,
    }}>
      <Box sx={{ px: '10%' }}>
        <PrimaryHeading sx={{
          textAlign: 'center',
          py: 5
        }}>
          Proven. Trusted. <span style={{
            color: 'white',
            background: 'linear-gradient(270.29deg, #43B0D7 0.24%, #0D2663 99.75%)',
            opacity: '90%',
            marginLeft: '5px',
          }}>Growing.</span>
        </PrimaryHeading>
      </Box>
      <Grid container spacing={4} justifyContent="center" sx={{ px: '10%' }}>
        {statsData.map((stat, index) => (
          <Grid item xs={12} sm={6} md={3} key={stat.label}>
            <Box
              sx={{
                background: "linear-gradient(#0D2663 10%, #43B0D7)",
                // background: "linear-gradient(#43B0D7,#0D2663 90%)",
                color: "#edf2f4",
                textAlign: "center",
                p: 3,
                borderRadius: 2,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                minHeight: 200,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Typography
                  variant="h4"
                  component="div"
                  className="odometer"
                  ref={(el) => (odometerRefs.current[index] = el)}
                  sx={{
                    fontFamily: 'Lato, sans-serif',
                    fontWeight: "bold",
                    fontSize: "52px",
                    display: "inline-block",
                    lineHeight: 1,
                  }}
                />
                {stat.label === "Customer Satisfaction Rate" ? (
                  <Typography
                    component="span"
                    sx={{
                      fontFamily: 'Lato, sans-serif',
                      fontSize: "20px",
                      ml: 0.5,
                    }}
                  >
                    %
                  </Typography>
                ) : (
                  stat.plus && (
                    <Typography
                      component="span"
                      sx={{
                        fontFamily: 'Lato, sans-serif',
                        fontSize: "20px",
                        ml: 0.5,
                      }}
                    >
                      +
                    </Typography>
                  )
                )}
              </Box>
              <Typography
                variant="subtitle1"
                sx={{
                  fontFamily: 'Lato, sans-serif',
                  fontSize: "18px",
                  wordBreak: "break-word",
                  mt: 1,
                  px: 1,
                }}
              >
                {stat.label}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default NumberCounter;